import { useState, useCallback, createContext, useContext, useRef } from 'react'
import type { ReactNode } from 'react'

interface Toast {
  id: number
  type: 'success' | 'error' | 'info'
  message: string
}

interface ToastContextValue {
  addToast: (toast: Omit<Toast, 'id'>) => void
}

const ToastContext = createContext<ToastContextValue>({ addToast: () => {} })

export function useToast() {
  return useContext(ToastContext)
}

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<Toast[]>([])
  const nextIdRef = useRef(0)

  const addToast = useCallback((toast: Omit<Toast, 'id'>) => {
    const id = ++nextIdRef.current
    setToasts(prev => [...prev, { ...toast, id }])
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3000)
  }, [])

  return (
    <ToastContext value={{ addToast }}>
      {children}
      <div style={{
        position: 'fixed', bottom: 20, right: 20, display: 'flex',
        flexDirection: 'column', gap: 8, zIndex: 9999,
      }}>
        {toasts.map(t => (
          <div key={t.id} style={{
            padding: '12px 20px', borderRadius: 8, color: '#fff', fontSize: 14,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            background: t.type === 'error' ? '#ef4444' : t.type === 'success' ? '#22c55e' : '#3b82f6',
          }}>
            {t.message}
          </div>
        ))}
      </div>
    </ToastContext>
  )
}
